import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const Input = z.object({
  website: z.string().trim().min(3).max(255),
});

/**
 * Public on purpose: the first onboarding screen runs before any account
 * exists. It only reads a public homepage and returns facts that already
 * passed the quality gate, so there is nothing account-scoped to leak.
 */
export const lookupSiteBasics = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => Input.parse(data))
  .handler(async ({ data }) => {
    const { lookupBasics } = await import("@/lib/site-basics.server");
    return await lookupBasics(data.website);
  });
